import api from '../../api/openstack'

export default {
  namespaced: true,

  actions: {
    async deleteRule ({ commit }, data) {
      commit('setLoadingState', true, {root: true})
      await api.securitygrouprules.deleteRule({ commit }, data.id)
      commit('setLoadingState', false, {root: true})
    },
    async createNewRule ({ commit }, data) {
      commit('setLoadingState', true, {root: true})
      await api.securitygrouprules.createNewRule({commit}, data)
      commit('setLoadingState', false, {root: true})
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/securitygrouprules.js